import { ICONES, type NomIcone } from '../config/icons';

interface Props {
  nom: NomIcone;
  className?: string;
}

/** Icône SVG au trait, jeu utilisé dans toute la maquette. */
export function Icone({ nom, className = 'w-4 h-4' }: Props): JSX.Element {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d={ICONES[nom]} />
    </svg>
  );
}
